import React, {useState, useEffect} from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, Link, NavLink } from 'react-router-dom';

function SearchForm(){

    var updatedList;
    var countSuggesstion = 0;

    const navigate = useNavigate();


    /******Get data from Topic Bucket*****/
    const topicBucketState =  useSelector(state => state.TopicBucket);
    const questionsArray = topicBucketState.bucket.owner_question ?? "";
    const [searchText, setSearchText] = useState("");
    const [searchedItems, setSearchedItems] =  useState([]);

    /****Keyword type*****/
    const filterList = (event) =>{

        setSearchText(event.target.value);

        if(event.target.value === ""){
            /*****If Empty value****/
           setSearchedItems([]);
        }else if(questionsArray.length>0)
        {   /*****If have some text for search*******/
            updatedList = questionsArray.filter(function(item){
                var post_title = item.post_title;
                return post_title.toLowerCase().search(
                    event.target.value.toLowerCase()) !== -1;
            });

            /****Set filtered data on local storage****/
            setSearchedItems(updatedList);

        }

      }

    /******When Clicked on searched items******/
    const handleClickOnSuggesstions = (e) => {
        setSearchedItems([]);
    }

    const handleButtonClicked = (e) =>{
        e.preventDefault();
        setSearchedItems([]);
        navigate('/search/'+searchText);
    }
      

  return (
    <>

    {/* .show-search-suggestion */}
    <div className={searchedItems.length === 0 ? 'search-hold' :  'show-search-suggestion search-hold'}>
        <div className='search-form-field'>

            <form onSubmit = {handleButtonClicked}>

            <input type="text" name="text" className="form-control form-control-lg" value={searchText} placeholder="Search" onChange={(e) => filterList(e)}/>

            <button className="search-btn"  type="submit"><span className="material-icons-outlined">search</span></button>

            </form>

        </div>

        <ul className="suggestion-search">
        {searchedItems && 
            searchedItems.map(function(element,index) {
                /*******Show results till 10th row******/
                if(countSuggesstion<10){
                    const {ID, post_title } = element;
                    return <li className="list-suggestion-search" key={index}><Link className='parent-figure' onClick={(e)=> handleClickOnSuggesstions(e)} key={index} to={"/query/"+ID}>{post_title}</Link></li>
                }
                countSuggesstion++;
            })
        }

        {searchedItems.length>10 && <li className="more-questions" onClick={(e)=> handleButtonClicked(e)}>more</li>} 

        </ul>
        
      </div>

      

      </>
    )
}

export default SearchForm;
